module.exports = __webpack_public_path__ + "static/media/button-loading.dd545f09.gif";


//////////////////
// WEBPACK FOOTER
// ./src/resource/img/button-loading.gif
// module id = 65
// module chunks = 0